var chunkToChildrenMap = {
	"889": [
		2402,
		9479
	],
	"3261": [
		2402,
		9479
	],
	"5545": [
		1096,
		8701,
		4983,
		2301
	],
	"7977": [
		2402,
		9479
	],
	"8165": [
		2402,
		9479
	],
	"8744": [
		1096,
		8701,
		4983,
		2301
	],
	"9516": [
		2402
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));